<template src="@/templates/reservations/preferences.html"></template>

<script>
import entityStore from '@/store/entityStore';

export default {
  props: [
    'reservationId',
    'reservation',
  ],
  data() {
    return {
      entity: entityStore.state,
      passengers: this.reservation.passengers,
    };
  },
  methods: {
    getNotesArray(notes, predicate) {
      return Object.keys(notes)
        .filter(key => predicate(key))
        .reduce((res, key) => (res[key] = notes[key], res), {});
    },
    getGeneralNotes(passenger) {
      return this.getNotesArray(passenger.essentials, (index) => {
        return index === 'Algemeen' || index === 'Contact';
      });
    },
    getPreferenceNotes(passenger) {
      return this.getNotesArray(passenger.preferences, (index) => {
        return index !== 'Algemeen' && index !== 'Contact';
      });
    },
    getEssentialNotes(passenger) {
      return this.getNotesArray(passenger.essentials, (index) => {
        return index !== 'Algemeen' && index !== 'Contact';
      });
    },
    passengerHasData(passenger) {
      return true;
    },
  },
};
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// preferences.vue?6ee60684